// Reusable query builder for API requests
export const buildQueryParams = (payload = {}) => {
  const queryParams = new URLSearchParams();
  
  // Add standard query parameters
  if (payload['page']) queryParams.append('page', payload['page']);
  if (payload['limit']) queryParams.append('limit', payload['limit']);
  if (payload['viewId']) queryParams.append('viewId', payload['viewId']);
  if (payload['search']) queryParams.append('search', payload['search']);
  if (payload['pipeline']) queryParams.append('pipeline', payload['pipeline']);
  if (payload['sort']) queryParams.append('sort', JSON.stringify(payload['sort']));
  
  // Handle filters
  if (payload['filters']) {
    // Check if filters is already a MongoDB query object
    if (typeof payload['filters'] === 'object' && (payload['filters']['$and'] || payload['filters']['$or'] || Object.keys(payload['filters']).some(k => k.indexOf('$') >= 0))) {
      // It's a MongoDB query, send as JSON
      queryParams.append('filters', JSON.stringify(payload['filters']));
    } else {
      // Legacy key-value filters
      Object.entries(payload['filters']).forEach(([key, value]) => {
        if (value !== undefined && value !== '') queryParams.append(`filters[${key}]`, typeof value === 'object' ? JSON.stringify(value) : value);
      });
    }
  }
  
  return queryParams;
};